import { useEffect, useRef } from "react";

import { useRemoteConfigContext } from "@shapr3d/frontend-lib";
import { useQuery } from "@tanstack/react-query";
import stableStringify from "json-stable-stringify";

import { accountQueryKey } from "../../../hooks/useAccount";
import type { AccountResponseData } from "../../../hooks/useAccountTypes";
import usePrevious from "../../../hooks/usePrevious";

const getTraits = (data: AccountResponseData | undefined) => {
  const userID = data?.id ?? "";
  const teamIds = data?.teams.map(({ id }) => id).join(",") ?? "";
  const isInternalUser = data?.email?.endsWith("@shapr3d.com") ?? false;

  return { userID, teamIds, isInternalUser };
};

export const IdentifyLoggedInUser = () => {
  const { remoteConfigClient, isLoading } = useRemoteConfigContext();
  const { data, isFetching } = useQuery<AccountResponseData>({
    queryKey: accountQueryKey,
    enabled: false,
  });
  useEffect(() => {
    if (!isLoading) {
      isIdentifyCalled.current = false;
    }
  }, [isLoading]);

  useEffect(() => {
    if (isFetching) {
      remoteConfigClient?.setIsLoading(true);
    }
  }, [isFetching, remoteConfigClient]);

  const previousData = usePrevious(data);
  const isIdentifyCalled = useRef(false);
  useEffect(() => {
    if (data && remoteConfigClient) {
      const traits = getTraits(data);
      const previousTraits = getTraits(previousData);
      if (stableStringify(traits) !== stableStringify(previousTraits)) {
        remoteConfigClient.setIsLoading(true);
        isIdentifyCalled.current = true;
        remoteConfigClient.identify(traits.userID, {
          is_internal_user: traits.isInternalUser,
          team_ids: traits.teamIds,
        });
      } else if (!isIdentifyCalled.current) {
        remoteConfigClient.setIsLoading(isFetching);
      }
    }
  }, [data, previousData, isFetching, remoteConfigClient]);

  return null;
};
